var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visible-icon",attrs:{"title":_vm.isVisible ? 'Widget visible on Player' : 'Widget hidden on Player'},on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('i',{staticClass:"material-icons-outlined"},[_vm._v(" "+_vm._s(_vm.isVisible ? 'visibility' : 'visibility_off')+" ")])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }